import useKeyDown from "./useKeyDown";

const CLOSE_KEYS = ["Undo", "Escape", "Cancel", "GoBack", "GoHome"];

const useEscape = (callback: (e: KeyboardEvent) => void) => {
  useKeyDown((e) => {
    if (CLOSE_KEYS.includes(e.key)) {
      callback(e);
    }
  });
};

export default useEscape;
